import { BrowserRouter } from 'react-router-dom';
import { AxiosProvider } from './lib/axios/use-axios';
import { MeinAutoApp } from './main-layout';
import { LoginProvider } from './security/login';
import deDE from 'antd/locale/de_DE';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import { ConfigProvider, notification } from 'antd';

export const App = (): React.ReactElement => {
    dayjs.locale('de');

    notification.config({ placement: 'bottomRight' });

    return (
        <AxiosProvider>
            <LoginProvider>
                <ConfigProvider
                    locale={deDE}
                    theme={{
                        token: {
                            colorPrimary: '#317383',
                        },
                        components: {
                            Layout: {
                                headerBg: '#3E3E3E',
                                footerBg: '#3E3E3E',
                                headerHeight: 120,
                            },
                            Button: {
                                borderRadius: 2,
                                primaryShadow: 'none',
                                defaultShadow: 'none',
                                dangerShadow: 'none',
                            },
                            Typography: {
                                titleMarginBottom: '0.5em',
                                titleMarginTop: 0,
                            },
                        },
                    }}
                >
                    <BrowserRouter>
                        <MeinAutoApp />
                    </BrowserRouter>
                </ConfigProvider>
            </LoginProvider>
        </AxiosProvider>
    );
};

export default App;

